import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import ReactTable from "react-table";
import * as config from '../Configuration/Config.js'

class AdminCustomersGrid extends Component {
    constructor() {
        super();

        this.handleNewCustomer = this.handleNewCustomer.bind(this)

        this.state = {
            loaded: false,
            redirect_new_customer: false,
            customers: []
        }
    }

    componentDidMount() {
        // get customer list
        var that = this;

        const uri = config.getUriPath('customers')
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
                console.log(response);
                throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {
            that.setState({ customers: data, loaded: true });
          });
    }

    handleNewCustomer(event) {
        event.preventDefault();

        this.setState({redirect_new_customer: true});
    }

    render() {

        if (this.state.loaded === false){
            return <div></div>;
        }

        if (this.state.redirect_new_customer) {
            return <Redirect to="/admin/customers/new" />
        }

        const customers = this.state.customers;

        if (customers === null || customers.length === 0) {
            return <div className='grid-wrapper'>
                    <div className="center-div">
                        <div className="addNewButton">
                                <button className="btn btn-primary" onClick={this.handleNewCustomer}>Add New</button>
                        </div>
                    </div>

                    <br/>
                    <div className='ReactTableCenter center-div'>
                    <h1>No Customers Found</h1> 
                    </div>               
            </div>
        }

        return <div className="grid-wrapper">
                    <div className="center-div">
                        <h1>Customers</h1>
                    </div>
                    <div className="addNewButton">
                            <button className="btn btn-primary" onClick={this.handleNewCustomer}>Add New Customer</button>
                    </div>
                    <div className="ReactTableCenter">
                        <ReactTable
                            data={customers}
                            minRows="0"
                            columns={[
                                {
                                    accessor: "customer_id",
                                    width: 100,
                                    resizable: false,
                                    Header: "Edit",
                                    style: { textAlign: "center"},
                                    Cell: row=>( 
                                        <div className="gridButton">                                       
                                            <a href={'/admin/customers/' + row.value} className="btn btn-success cstedit" role="button">EDIT</a>
                                        </div>
                                    )
                                },
                                {
                                    accessor: "customer_id",
                                    width: 100,
                                    resizable: false,
                                    Header: "Divisions",
                                    style: { textAlign: "center"},
                                    Cell: row=>(
                                        <div className="gridButton">
                                             <a href={"/admin/business/divisions/" + row.value} className="btn btn-info cstdivisions" role="button">DIVISIONS</a>
                                        </div>                                       
                                    )
                                },
                                // {
                                //     accessor: "customer_id",
                                //     width: 75,
                                //     resizable: false,
                                //     Header: "Roles",
                                //     style: { textAlign: "center"},
                                //     Cell: row=>(
                                //         <a href={"/admin/security/roles/" + row.value}><i className="fas fa-edit"></i></a>
                                //     )
                                // },
                                {
                                    accessor: "customer_id",
                                    width: 100,
                                    resizable: false,
                                    Header: "List Users",
                                    style: { textAlign: "center"},
                                    Cell: row=>(
                                        <div className="gridButton">
                                            <a href={"/admin/users/" + row.value} className="btn btn-warning cstusers" role="button">USERS</a>
                                        </div>                                       
                                    )
                                },
                                {
                                    Header: "Customer Name",
                                    accessor: "customer_name",
                                    Cell: row=>(
                                    <div className="gridValue">
                                        {row.value}
                                    </div>
                                )
                                },
                                {
                                    Header: "Abbreviation",
                                    accessor: "customer_abbreviation",
                                    Cell: row=>(
                                    <div className="gridValue">
                                        {row.value}
                                    </div>
                                )
                                },
                                {
                                    Header: "Group Friendly Name",
                                    accessor: "customer_group_friendly_name",
                                    Cell: row=>(
                                    <div className="gridValue">
                                        {row.value}
                                    </div>
                                )
                                },
                                {
                                    Header: "Group Id",
                                    accessor: "customer_group_id",
                                    Cell: row=>(
                                    <div className="gridValue">
                                        {row.value}
                                    </div>
                                )
                                // },
                                // {
                                //     Header: "Customer City",
                                //     accessor: "customer_address_city"
                                }
                            ]}
                            //defaultPageSize={15}
                            defaultPageSize={customers.length}
                            showPagination={false}
                            className="-striped -highlight"
                        >
                        </ReactTable>
                        <br></br>
                        <br></br>
                        <br></br>
                    </div>
            </div>
    }
}

export default AdminCustomersGrid


// WEBPACK FOOTER //
// ./src/Components/AdminCustomers/AdminCustomersGrid.js